// Inicialização do Module Federation
import('./main.js').catch((err) => console.error('Erro ao carregar a aplicação:', err))
